export const apiServerUrl = process.env.REACT_APP_API_SERVER;



// WEBPACK FOOTER //
// ./src/config.js